import { render, staticRenderFns } from "./AgrupamentosTab.vue?vue&type=template&id=1aa34748&"
import script from "./AgrupamentosTab.vue?vue&type=script&lang=js&"
export * from "./AgrupamentosTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports